import PaginationItem from './PaginationItem';
import {Table} from '@tanstack/react-table';

interface PaginationProps<T> {
    table: Table<T>;
}

const paginate = (currentPage: number, lastPage: number): (string | number)[] | null => {
    if (!currentPage || !lastPage) {
        return null;
    }

    const items: (string | number)[] = [1];

    if (currentPage === 1 && lastPage === 1) {
        return items;
    }

    if (currentPage > 3) {
        items.push('...');
    }

    const r = 1;
    const r1 = currentPage - r;
    const r2 = currentPage + r;

    for (let i = r1 > 2 ? r1 : 2; i <= Math.min(lastPage, r2); i++) {
        items.push(i);
    }

    if (r2 + 1 < lastPage) {
        items.push('...');
    }

    if (r2 < lastPage) {
        items.push(lastPage);
    }

    return items;
};

const Pagination = <T,>({
    table: {
        previousPage,
        getCanPreviousPage,
        setPageIndex,
        getPageCount,
        nextPage,
        getState,
        getCanNextPage,
    },
}: PaginationProps<T>): JSX.Element => {
    const currentPage = getState().pagination.pageIndex + 1;
    const pagesItems = paginate(currentPage, getPageCount());

    return (
        <ul className="pagination">
            <PaginationItem
                disabled={!getCanPreviousPage()}
                content={<i className="previous"></i>}
                action={() => previousPage()}
            />
            {pagesItems?.map((item, key) => (
                <PaginationItem
                    key={key}
                    disabled={item === '...'}
                    content={`${item}`}
                    action={() => {
                        if (typeof item === 'number') {
                            setPageIndex(item - 1);
                        }
                    }}
                    {...(item === currentPage && {active: true})}
                />
            ))}
            <PaginationItem
                disabled={!getCanNextPage()}
                content={<i className="next"></i>}
                action={() => nextPage()}
            />
        </ul>
    );
};

export default Pagination;
